import React, { useState, useEffect } from "react";
import Header from "./Header";
import HeroSection from "./HeroSection";
import ServicesSection from "./ServicesSection";
import ClientsSection from "./ClientsSection";
import CofoundersSection from "./CofoundersSection";
import ContactSection from "./ContactSection";
import FAQSection from "./FAQSection";
import Footer from "./Footer";
import DisclaimerPage from "./DisclaimerPage";
import RevealOnScroll from "./RevealOnScroll";

const LandingPage = () => {
  const [activeSection, setActiveSection] = useState('home');
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setActiveSection(sectionId);
    }
  };

  useEffect(() => {
    const handleShowDisclaimer = () => {
      setShowDisclaimer(true);
    };

    window.addEventListener('showDisclaimer', handleShowDisclaimer);
    return () => window.removeEventListener('showDisclaimer', handleShowDisclaimer);
  }, []);

  if (showDisclaimer) {
    return <DisclaimerPage onBack={() => setShowDisclaimer(false)} />;
  }

  return (
    <div className="dark-container">
      <Header activeSection={activeSection} scrollToSection={scrollToSection} />
      <main>
        <RevealOnScroll>
          <HeroSection />
        </RevealOnScroll>
        <RevealOnScroll>
          <ServicesSection />
        </RevealOnScroll>
        <RevealOnScroll>
          <ClientsSection />
        </RevealOnScroll>
        <RevealOnScroll>
          <CofoundersSection />
        </RevealOnScroll>
        <RevealOnScroll>
          <ContactSection />
        </RevealOnScroll>
        <RevealOnScroll>
          <FAQSection />
        </RevealOnScroll>
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;